module.exports = __webpack_public_path__ + "static/media/ID.0dd475e8.png";